import axios from "axios"
import React, {Component} from "react"
import ApiHelper from "src/ApiHelper"
import DeveloperPortalRecommendationsRow from "src/components/table/DeveloperPortalRecommendationsRow"
import DeveloperPortalStockDailyRow from "src/components/table/DeveloperPortalStockDailyRow"
class DeveloperPortalBrokerage extends Component{
    constructor(props){
        super(props)
        this.state = {
            lastetchedtimestamp: "",
            recommendations: [],
            recommendationsoffset: 0,
            recommendationsautoupdatestatus: 0,
            ordersautoupdatestatus: 0,
            uncalculatedarthscorerecommendationscount: 0,
            dailystockhistory: [],
            dailystockhistorydates: [],
            leastrelevantcompany: null,
            calculationsresults: "",
            step1status:"N/A",
            step2status:"N/A",
            step3status:"N/A",
            getdailystockhistoryform: {
                symbol: ""
            },
            status: ""
        }
    }
    showStockDailyHistory(){
        var rows = [<DeveloperPortalStockDailyRow key={0} open="Open" close="Close" volume="Volume" high="High" low="Low" date="Date"/>]
        for(var i = 0; i < (this.state.dailystockhistory.length > 30? 30: this.state.dailystockhistory.length); i++){
            var stockdaily = this.state.dailystockhistory[i]
            rows.push(<DeveloperPortalStockDailyRow key={i + 1} open={stockdaily["1. open"]} high={stockdaily["2. high"]} low={stockdaily["3. low"]} close={stockdaily["4. close"]} volume={stockdaily["5. volume"]} date={this.state.dailystockhistorydates[i]}/>)
        }
        return rows
    }
    showRecommendations(){
        var rows = []
        for(var i = 0; i < this.state.recommendations.length; i++){
            var recommendation = this.state.recommendations[i]
            rows.push(<DeveloperPortalRecommendationsRow key={recommendation.serial_id} company={recommendation.company} action={recommendation.action} symbol={recommendation.symbol} targetprice={recommendation.targetprice}/>)
        } 
        return rows
    }
    render(){
        return <div className="c_developerportal_content"> 
            <h4>Recommendations</h4>
            {/* Last Fetched On: {this.state.lastetchedtimestamp} <button className="c_developerportal_buttononwhite" onClick={this.refreshRecommendations.bind(this)}>Refresh</button><br/>
            {this.state.uncalculatedarthscorerecommendationscount} Arth Scores are yet to be calculated. <button className="c_developerportal_buttononwhite" onClick={this.calculateArthScores.bind(this)}>Calculate</button><br/>
            <p>{this.state.calculationsresults}</p> */}
            Showing {this.state.recommendationsoffset} - {this.state.recommendationsoffset + this.state.recommendations.length}<br/>
            <p>{this.state.status}</p>
            <div className="c_developerportal_searchresults">
                {this.showRecommendations()}
            </div>
            <button onClick={this.decrementRecommendationsOffset.bind(this)} className="c_developerportal_buttononwhite">Prev</button>
            <button onClick={this.incrementRecommendationsOffset.bind(this)} className="c_developerportal_buttononwhite">Next</button>
            <hr/>
            <h4>Recommendation Steps</h4>
            <button className="c_developerportal_buttononwhite" onClick={this.onStep1Clicked.bind(this)}>Step 1</button> Fetch Recommendations, status: {this.state.step1status}<br/>
            <button className="c_developerportal_buttononwhite" onClick={this.onStep2Clicked.bind(this)}>Step 2</button> Identify symbols, status: {this.state.step2status}<br/>
            <button className="c_developerportal_buttononwhite" onClick={this.onStep3Clicked.bind(this)}>Step 3</button> Calculate Orders, status: {this.state.step3status}<br/>
            Least Relevant Company : {(() => {
                if(!this.state.leastrelevantcompany)return ""
                var date = new Date(this.state.leastrelevantcompany.lastchecked * 1000)
                return this.state.leastrelevantcompany.company + " as of " + date.getDate() + "/" + (date.getMonth() + 1) + " updated on " + date.getHours() + ":" + date.getMinutes()
            })()}            
            <hr/>
            <h4>Auto Update Recommendations</h4>
            Status: {this.state.recommendationsautoupdatestatus === 0?"Inactive": "Active"}<br/>
            {this.state.recommendationsautoupdatestatus === 0?<button className="c_developerportal_buttononwhite" onClick={this.startRecommendationsAutoUpdate.bind(this)}>Turn On</button>: <button className="c_developerportal_buttononwhite" onClick={this.stopRecommendationsAutoUpdate.bind(this)}>Turn Off</button>}
            <br/>
            <hr/>
            <h4>Auto Update Orders</h4>
            Status: {this.state.ordersautoupdatestatus === 0?"Inactive": "Active"}<br/>
            {this.state.ordersautoupdatestatus === 0?<button className="c_developerportal_buttononwhite" onClick={this.startOrdersAutoUpdate.bind(this)}>Turn On</button>: <button className="c_developerportal_buttononwhite" onClick={this.stopOrdersAutoUpdate.bind(this)}>Turn Off</button>}
            <hr/>
            <h4>Get Stock Daily History</h4>
            <input name="symbol" className="c_developerportal_inputonwhite" onChange={this.getDailyStockHistoryFormChangedHandler.bind(this)} placeholder="Symbol"/><button className="c_developerportal_buttononwhite" onClick={this.getDailyStockHistory.bind(this)}>Sumbit</button>
            <div className="c_developerportal_searchresults">
                {this.showStockDailyHistory()}
            </div>
            <hr/>
        </div>
    }
    startOrdersAutoUpdate(){
        var autoupdate = axios.post(ApiHelper.brokerRecos.startOrdersAutoUpdate)
        autoupdate.then(response => {
            alert(response.data.error_message)
            this.getAutoUpdateStatusFull()
        }, error => {
            alert(error.response.data.error_message)
        })
    }
    stopOrdersAutoUpdate(){
        var autoupdate = axios.post(ApiHelper.brokerRecos.stopOrdersAutoUpdate)
        autoupdate.then(response => {
            alert(response.data.error_message)
            this.getAutoUpdateStatusFull()
        }, error => {
            alert(error.response.data.error_message)
        })
    }
    startRecommendationsAutoUpdate(){
        var autoupdate = axios.post(ApiHelper.brokerRecos.startRecommendationsAutoUpdate)
        autoupdate.then(response => {
            alert(response.data.error_message)
            this.getAutoUpdateStatusFull()
        }, error => {
            alert(error.response.data.error_message)
        })
    }
    stopRecommendationsAutoUpdate(){
        var autoupdate = axios.post(ApiHelper.brokerRecos.stopRecommendationsAutoUpdate)
        autoupdate.then(response => {
            alert(response.data.error_message)
            this.getAutoUpdateStatusFull()
        }, error => {
            alert(error.response.data.error_message)
        })
    }
    getAutoUpdateStatusFull(){
        const statuses = axios.post(ApiHelper.logs.getStepLogs)
        statuses.then(response => {
            const newstate = {...this.state}
            newstate.step1status = response.data.data.step1log
            newstate.step2status = response.data.data.step2log
            newstate.step3status = response.data.data.step3log
            newstate.recommendationsautoupdatestatus = response.data.data.recommendationsautoupdateflag
            newstate.ordersautoupdatestatus = response.data.data.ordersautoupdateflag
            this.setState(newstate)
        }, error => {

        })
    }

    onStep1Clicked(){
        const newstate = {...this.state}
        newstate.step1status = "Working..."
        this.setState(newstate)
        var step1 = axios.post(ApiHelper.brokerRecos.refreshRecommendations)
        step1.then(response => {
            const newstate = {...this.state}
            newstate.step1status = response.data.error_message
            this.setState(newstate)
        }, error => {
            const newstate = {...this.state}
            newstate.step1status = "An Error Occured"
            this.setState(newstate)
        })
    }
    onStep2Clicked(){
        const newstate = {...this.state}
        newstate.step2status = "Working..."
        this.setState(newstate)
        var step2 = axios.post(ApiHelper.brokerRecos.updateRecommendationSymbols)
        step2.then(response => {
            const newstate = {...this.state}
            newstate.step2status = response.data.error_message
            this.setState(newstate)
        }, error => {
            const newstate = {...this.state}
            newstate.step2status = "An Error Occured"
            this.setState(newstate)
        })
    }
    onStep3Clicked(){
        const newstate = {...this.state}
        newstate.step3status = "Working..."
        this.setState(newstate)
        var step3 = axios.post(ApiHelper.brokerRecos.updateOrders)
        step3.then(response => {
            const newstate = {...this.state}
            newstate.step3status = response.data.error_message
            this.setState(newstate, ()=> {
                this.getLeastRelevantCompany()
            })
        }, error => {
            const newstate = {...this.state}
            newstate.step3status = error.response.data.error_message
            this.setState(newstate, ()=> {
                this.getLeastRelevantCompany()
            })
        })
    }
    getLeastRelevantCompany(){
        var getleastrelevant = axios.post(ApiHelper.companies.getLeastRelevantCompany)
        getleastrelevant.then(response => {
            const newstate = {...this.state}
            newstate.leastrelevantcompany = response.data.data
            this.setState(newstate)
        }, error => {
            const newstate = {...this.state}
            newstate.leastrelevantcompany = null
            this.setState(newstate)
        })
    }
    incrementRecommendationsOffset(){
        const newstate = {...this.state}
        newstate.recommendationsoffset += 10
        this.setState(newstate, () => {
            this.getRecommendations()
        })
    }
    decrementRecommendationsOffset(){
        const newstate = {...this.state}
        newstate.recommendationsoffset -= this.state.recommendationsoffset - 10 >= 0? 10 : 0
        this.setState(newstate, () => {
            this.getRecommendations()
        })
    }
    componentDidMount(){
        this.props.setLoading(false)
        this.getRecommendations()
        this.getAutoUpdateStatusFull()
        this.getLeastRelevantCompany()
    }
    getDailyStockHistoryFormChangedHandler(event){
        const newstate = {...this.state}
        newstate.getdailystockhistoryform[event.target.name] = event.target.value
        newstate.status = ""
        this.setState(newstate)
    }
    getDailyStockHistory(){
        var getdailyhistory = axios.post(ApiHelper.alphaVantage.getDailyStockHistory, {symbol: this.state.getdailystockhistoryform.symbol}, ApiHelper.getAccessTokenHeaderConfig())
        getdailyhistory.then(response => {
            console.log(Object.values(response.data.data["Time Series (Daily)"]))
            const newstate = {...this.state}
            newstate.dailystockhistory = Object.values(response.data.data["Time Series (Daily)"])
            newstate.dailystockhistorydates = Object.keys(response.data.data["Time Series (Daily)"])
            newstate.status = ""
            this.setState(newstate)
        }, error => {
            console.log(error)
        })
    }
    refreshRecommendations(){
        var refreshrecommendations = axios.post(ApiHelper.brokerRecos.refreshRecommendations, {}, ApiHelper.getAccessTokenHeaderConfig())
        const newstate = {...this.state}
        newstate.status = "Working..."
        this.setState(newstate)
        refreshrecommendations.then(response => {
            console.log("Recommendations Refreshed")
            this.getRecommendations()
            this.getLastFetchedLog()
            this.getUncalculatedArthScoreRecommendationsCount()
        }, error => {
            console.log(error)
        })
    }
    getRecommendations(){
        var getrecommendations = axios.post(ApiHelper.brokerRecos.getRecommendationsByOffset, {offset: this.state.recommendationsoffset}, ApiHelper.getAccessTokenHeaderConfig())
        getrecommendations.then(response => {
            const newstate = {...this.state}
            newstate.recommendations = response.data.data
            this.setState(newstate)
        }, error => {
            console.log(error)
        })
    }
    getLastFetchedLog(){
        var getlastfetchedlog = axios.post(ApiHelper.brokerRecos.getLastFetchedLog, {}, ApiHelper.getAccessTokenHeaderConfig())
        getlastfetchedlog.then(response => {
            var thedate = new Date(response.data.data[0].lasttimestamp * 1000)
            const newstate = {...this.state}
            newstate.lastetchedtimestamp = thedate.toDateString() + " " + thedate.toLocaleTimeString()
            this.setState(newstate)
        }, error => {
            console.log(error)
        })
    }
}
export default DeveloperPortalBrokerage